export default {
    "template": "componentsCompany/global/CompanySettings",
    "default_number_format": {
        "decimal_point": ",",
        "decimal_length": 2
    },
    "new_design": true,
    "design_v2": true,
    "design_v2_theme": {
        "light": {
            "primary": "#7C5CFF",
            "primary_hover": "#6A4FF0",
            "primary_soft": "#EDE9FF",
            "primary_softer": "#F7F5FF",
            "primary_ring": "rgba(124, 92, 255, 0.18)",
            "on_primary": "#FFFFFF"
        },
        "dark": {
            "primary": "#8B6CFF",
            "primary_hover": "#9D82FF",
            "primary_soft": "rgba(139, 108, 255, 0.16)",
            "primary_softer": "rgba(139, 108, 255, 0.08)",
            "primary_ring": "rgba(139, 108, 255, 0.32)",
            "on_primary": "#FFFFFF"
        }
    },
    "menu_template": "componentsCompany/global/header/MenuComponent",
    "paginator": {
        "per_page_sizes": [
            10,
            25,
            50,
            100
        ],
        "per_page_default": 10,
        "per_page_by_name": {
            "cards": 25
        }
    },
    "body_size_bootstrap_validator_white_list": [
        "export-import/*",
        "api/export-import/*"
    ]
}